<template>
  <responsive-modal v-model="visible" title="Integrar Funnel Control">
    <div class="tool-modal-funnel-control">
      <a
        href="https://funnelcontrol.online/"
        target="_blank"
        class="integration-link"
      >
        Conheça a Funnel Control
        <i class="ph ph-arrow-square-out" />
      </a>

      <div>
        <div class="d-flex justify-content-center" v-if="!form.token">
          <b-spinner variant="primary" />
        </div>

        <div v-else>
          <snow-input disabled v-model="form.token">
            <snow-button
              size="sm"
              variant="borderless"
              icon="ph ph-copy"
              @click="copyToken"
            />
          </snow-input>
        </div>
      </div>

      <action-dispatcher action="product/get" :parameters="{ limit: 500 }">
        <snow-select
          :disabled="form.id != null"
          id="product-select"
          label="Produto"
          v-model="form.product_id"
          :errors="errors.product_id"
          :options="products.map(({ id, name }) => ({ id, name }))"
        />
      </action-dispatcher>
      <snow-input
        label="Descrição da integração (Opcional)"
        id="description"
        v-model="form.description"
        :rules="rules.description"
      />
      <snow-input
        label="URL"
        id="url"
        v-model="form.url"
        :rules="rules.url"
        placeholder="Digite a URL..."
      />

      <action-dispatcher action="integration/getTypeEvents">
        <snow-checkboxes-dropdown
          label="Eventos disparados"
          id="events-select"
          v-model="form.events"
          :errors="errors.events"
          :options="normalizedTypeEvents"
        />
      </action-dispatcher>
      <div class="snow-submit-buttons">
        <snow-button
          size="lg"
          text="Cancelar"
          variant="gray"
          class="order-lg-0 order-1"
          @click="
            visible = false;
            clear();
          "
        />
        <snow-button
          size="lg"
          text="Salvar"
          :disabled="!isValid"
          :loading="loading"
          @click="submit"
        />
      </div>
    </div>
  </responsive-modal>
</template>
<script>
import { formFields } from "@/functions/helpers";
import { mapState } from "vuex";
import { required, validUrl } from "@/functions/validation";
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    integrationToEdit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ...formFields(
        ["product_id", "url", "status", "description", "events", "name"],
        {
          events: [],
          name: "funnel_control",
          extras: { is_json: true }
        }
      ),
      loading: false,
      visible: false
    };
  },
  watch: {
    value(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit("input", v);
      if (v && !this.integrationToEdit) {
        this.$store
          .dispatch("integration/getFunnelControlToken")
          .then(this.setToken);
      }

      if (!v) {
        this.clear();
      }
    },
    integrationToEdit(v) {
      if (v) {
        this.form = {
          ...this.form,
          ...v
        };
        this.form.events = v.events.map(e => e.event);
        this.form.product_id = v.events[0].product_id;
        this.form.extras = v.extras || { is_json: true };
      }
    }
  },
  computed: {
    ...mapState("product", ["products"]),
    ...mapState("integration", ["typeEvents"]),
    isValid() {
      return (
        this.form.events.length &&
        this.form.product_id &&
        this.form.url &&
        this.form.token
      );
    },
    normalizedTypeEvents() {
      return this.typeEvents.map(e => ({
        id: e.id,
        label: e.name
      }));
    },
    rules() {
      return {
        url: [required(), validUrl()]
      };
    }
  },
  methods: {
    copyToken() {
      navigator.clipboard.writeText(this.form.token);
      this.$message.success("Token copiado");
    },
    setToken({ token }) {
      this.form.token = token;
    },
    clear() {
      this.form = {
        name: "funnel_control",
        events: [],
        extras: { is_json: true }
      };
      this.$emit("clear-edit");
    },
    submit() {
      if (this.loading) return;

      this.loading = true;
      let data = { ...this.form };
      data.events = data.events.map(e => {
        return { event: e };
      });
      let action = "integration/postIntegration";
      if (this.integrationToEdit) {
        data.id = this.integrationToEdit.id;
        action = "integration/putIntegration";
      }
      this.$store
        .dispatch(action, data)
        .then(() => {
          this.loading = false;
          this.visible = false;
          this.$emit("update-list");
          this.clear();
          this.$message.success("A integração foi salva!");
        })
        .catch(e =>
          this.handleErrors(
            e,
            "TRANSLATE_FIELD_INTEGRATION_MAP",
            "Erro ao salvar configuração"
          )
        )
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.tool-modal-funnel-control {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
